// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.similarity-search-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.similarity-search-page h1 {
  margin: 0 0 2rem 0;
  font-size: 2rem;
  color: #333;
}

.search-container {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.upload-section {
  margin-bottom: 2rem;
}

.upload-section h3 {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  color: #333;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}

.file-info p {
  margin: 0;
  flex: 1 1;
  color: #555;
}

.file-actions {
  display: flex;
  gap: 0.5rem;
}

.btn-clear {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  color: #555;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-clear:hover {
  background: #f8f9fa;
}

.btn-analyze {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  background: var(--button-color, #007bff);
  color: white;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-analyze:hover:not(:disabled) {
  background: var(--hover-color, #0056b3);
}

.btn-analyze:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-quick-search {
  padding: 0.5rem 1rem;
  border: 1px solid var(--button-color, #007bff);
  border-radius: 4px;
  background: white;
  color: var(--button-color, #007bff);
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.2s;
}

.btn-quick-search:hover:not(:disabled) {
  background: var(--button-color, #007bff);
  color: white;
}

.btn-quick-search:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.file-upload {
  padding: 2rem;
  border: 2px dashed #ddd;
  border-radius: 8px;
  text-align: center;
}

.btn-upload {
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background: var(--button-color, #007bff);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-upload:hover {
  background: var(--hover-color, #0056b3);
}

/* Drag & drop */
.upload-section.drag-over .file-upload,
.upload-section.drag-over .file-info {
  border: 2px solid #1976d2;
  background: #e3f2fd;
}

.upload-section.drag-over .file-upload {
  border-style: solid;
}

.upload-section.drag-over * {
  pointer-events: none;
}

.drop-hint {
  margin: 0.75rem 0 0 0;
  font-size: 0.85rem;
  color: #999;
}

.info-message {
  margin-top: 1rem;
  padding: 1rem;
  background: #e3f2fd;
  color: #1565c0;
  border-radius: 4px;
  border: 1px solid #bbdefb;
}

.btn-search {
  width: 100%;
  padding: 1rem;
  border: none;
  border-radius: 4px;
  background: var(--button-color, #007bff);
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 1rem;
}

.btn-search:hover:not(:disabled) {
  background: var(--hover-color, #0056b3);
}

.btn-search:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.error-message {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
}

/* Steps selection */
.steps-selection {
  margin: 1.5rem 0;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.steps-selection h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

.steps-description {
  margin: 0 0 1rem 0;
  font-size: 0.9rem;
  color: #666;
}

.steps-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.step-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background 0.2s;
}

.step-checkbox:hover {
  background: #e9ecef;
}

.step-checkbox input[type="checkbox"] {
  margin-top: 0.25rem;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.step-info {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.step-info strong {
  font-size: 0.95rem;
  color: #333;
}

.step-info small {
  font-size: 0.8rem;
  color: #666;
}

/* Comparison action button */
.comparison-action {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
}

.btn-compare {
  padding: 0.8rem 2rem;
  border: 2px solid var(--button-color, #007bff);
  border-radius: 8px;
  background: white;
  color: var(--button-color, #007bff);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-compare:hover {
  background: var(--button-color, #007bff);
  color: white;
}

/* Duplicate results */
.duplicate-results-section {
  margin-top: 1.5rem;
}

.no-duplicates-message {
  text-align: center;
  color: #666;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
}

/* MCP hint */
.mcp-hint {
  margin-top: 0.75rem;
  font-size: 0.85rem;
  color: #666;
  text-align: center;
}

/* Analyzing indicator */
.analyzing-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 1rem;
  margin: 1rem 0;
  background: #e3f2fd;
  border-radius: 6px;
  color: #1565c0;
  font-weight: 500;
}

.spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid #bbdefb;
  border-top: 2px solid #1976d2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Outlook accounts */
.outlook-accounts {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 1.5rem;
  font-size: 0.8rem;
}

.outlook-accounts-label {
  color: #999;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.outlook-account-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.outlook-account-email {
  color: #28a745;
}

.btn-outlook-disconnect {
  padding: 0.15rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: white;
  color: #999;
  cursor: pointer;
  font-size: 0.7rem;
  transition: all 0.2s;
}

.btn-outlook-disconnect:hover {
  border-color: #dc3545;
  color: #dc3545;
}

/* LAKPED-16.1 — entrada de documentos (solo clientes con ofertas y pedidos) */
.similarity-search-page .entrada-subtitulo {
  color: #6b7682;
  font-size: 14px;
  margin: -8px 0 18px;
  max-width: 760px;
}

.similarity-search-page .entrada-sin-documento {
  color: #6b7682;
  font-size: 13px;
  margin: 10px 2px 0;
}

.similarity-search-page .entrada-sin-documento button {
  border: none;
  background: none;
  padding: 0;
  color: #2c6ca8;
  font-family: inherit;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
}

.similarity-search-page .entrada-sin-documento button:hover { color: #1b4b76; }

/* LAKPED-16.1 — la entrada de documentos copia los valores del prototipo de Paula.
   Acotado a .entrada-documentos: las demás cuentas siguen viendo la pantalla de siempre. */
.entrada-documentos h1 { font-size: 26px; font-weight: 600; margin: 0 0 4px; }
.entrada-documentos .entrada-subtitulo { font-size: 14px; color: #666; margin: 0 0 20px; max-width: 760px; }

.entrada-documentos .search-container {
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  box-shadow: none;
  padding: 18px 20px;
}

.entrada-documentos .upload-section h3 { font-size: 15px; margin: 0 0 12px; }
.entrada-documentos .file-upload { padding: 0; border: none; }

.entrada-documentos .zona-arrastre {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 44px 24px;
  border: 2px dashed #d5d5d5;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.entrada-documentos .zona-arrastre:hover { border-color: #111; background: #fafafa; }

.entrada-documentos .zona-arrastre svg {
  width: 30px;
  height: 30px;
  fill: none;
  stroke: #111;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.entrada-documentos .zona-arrastre strong { font-size: 17px; color: #1b1b1b; }
.entrada-documentos .zona-arrastre span { font-size: 13px; color: #777; }

.entrada-documentos .entrada-sin-documento { font-size: 12.5px; color: #777; margin: 12px 2px 0; }
`, "",{"version":3,"sources":["webpack://./src/pages/SimilaritySearchPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;EAC9C,kBAAkB;EAClB,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,8DAA8D,cAAc,EAAE;;AAE9E;2FAC2F;AAC3F,yBAAyB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC7E,yCAAyC,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE3G;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,yCAAyC,eAAe,EAAE,gBAAgB,EAAE;AAC5E,mCAAmC,UAAU,EAAE,YAAY,EAAE;;AAE7D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2CAA2C,kBAAkB,EAAE,mBAAmB,EAAE;;AAEpF;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,4CAA4C,eAAe,EAAE,cAAc,EAAE;AAC7E,0CAA0C,eAAe,EAAE,WAAW,EAAE;;AAExE,6CAA6C,iBAAiB,EAAE,WAAW,EAAE,kBAAkB,EAAE","sourcesContent":[".similarity-search-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.similarity-search-page h1 {\n  margin: 0 0 2rem 0;\n  font-size: 2rem;\n  color: #333;\n}\n\n.search-container {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.upload-section {\n  margin-bottom: 2rem;\n}\n\n.upload-section h3 {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  color: #333;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n}\n\n.file-info p {\n  margin: 0;\n  flex: 1;\n  color: #555;\n}\n\n.file-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-clear {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  color: #555;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.btn-clear:hover {\n  background: #f8f9fa;\n}\n\n.btn-analyze {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 4px;\n  background: var(--button-color, #007bff);\n  color: white;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.btn-analyze:hover:not(:disabled) {\n  background: var(--hover-color, #0056b3);\n}\n\n.btn-analyze:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-quick-search {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--button-color, #007bff);\n  border-radius: 4px;\n  background: white;\n  color: var(--button-color, #007bff);\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.2s;\n}\n\n.btn-quick-search:hover:not(:disabled) {\n  background: var(--button-color, #007bff);\n  color: white;\n}\n\n.btn-quick-search:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.file-upload {\n  padding: 2rem;\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.btn-upload {\n  display: inline-block;\n  padding: 0.8rem 1.5rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.btn-upload:hover {\n  background: var(--hover-color, #0056b3);\n}\n\n/* Drag & drop */\n.upload-section.drag-over .file-upload,\n.upload-section.drag-over .file-info {\n  border: 2px solid #1976d2;\n  background: #e3f2fd;\n}\n\n.upload-section.drag-over .file-upload {\n  border-style: solid;\n}\n\n.upload-section.drag-over * {\n  pointer-events: none;\n}\n\n.drop-hint {\n  margin: 0.75rem 0 0 0;\n  font-size: 0.85rem;\n  color: #999;\n}\n\n.info-message {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #e3f2fd;\n  color: #1565c0;\n  border-radius: 4px;\n  border: 1px solid #bbdefb;\n}\n\n.btn-search {\n  width: 100%;\n  padding: 1rem;\n  border: none;\n  border-radius: 4px;\n  background: var(--button-color, #007bff);\n  color: white;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 1rem;\n}\n\n.btn-search:hover:not(:disabled) {\n  background: var(--hover-color, #0056b3);\n}\n\n.btn-search:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.error-message {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #f8d7da;\n  color: #721c24;\n  border-radius: 4px;\n  border: 1px solid #f5c6cb;\n}\n\n/* Steps selection */\n.steps-selection {\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.steps-selection h4 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.steps-description {\n  margin: 0 0 1rem 0;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.steps-checkboxes {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.step-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 4px;\n  transition: background 0.2s;\n}\n\n.step-checkbox:hover {\n  background: #e9ecef;\n}\n\n.step-checkbox input[type=\"checkbox\"] {\n  margin-top: 0.25rem;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.step-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.step-info strong {\n  font-size: 0.95rem;\n  color: #333;\n}\n\n.step-info small {\n  font-size: 0.8rem;\n  color: #666;\n}\n\n/* Comparison action button */\n.comparison-action {\n  display: flex;\n  justify-content: center;\n  margin: 1.5rem 0;\n}\n\n.btn-compare {\n  padding: 0.8rem 2rem;\n  border: 2px solid var(--button-color, #007bff);\n  border-radius: 8px;\n  background: white;\n  color: var(--button-color, #007bff);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-compare:hover {\n  background: var(--button-color, #007bff);\n  color: white;\n}\n\n/* Duplicate results */\n.duplicate-results-section {\n  margin-top: 1.5rem;\n}\n\n.no-duplicates-message {\n  text-align: center;\n  color: #666;\n  padding: 1rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n}\n\n/* MCP hint */\n.mcp-hint {\n  margin-top: 0.75rem;\n  font-size: 0.85rem;\n  color: #666;\n  text-align: center;\n}\n\n/* Analyzing indicator */\n.analyzing-indicator {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 1rem;\n  margin: 1rem 0;\n  background: #e3f2fd;\n  border-radius: 6px;\n  color: #1565c0;\n  font-weight: 500;\n}\n\n.spinner-small {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #bbdefb;\n  border-top: 2px solid #1976d2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Outlook accounts */\n.outlook-accounts {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 1.5rem;\n  font-size: 0.8rem;\n}\n\n.outlook-accounts-label {\n  color: #999;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.outlook-account-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.outlook-account-email {\n  color: #28a745;\n}\n\n.btn-outlook-disconnect {\n  padding: 0.15rem 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  background: white;\n  color: #999;\n  cursor: pointer;\n  font-size: 0.7rem;\n  transition: all 0.2s;\n}\n\n.btn-outlook-disconnect:hover {\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n/* LAKPED-16.1 — entrada de documentos (solo clientes con ofertas y pedidos) */\n.similarity-search-page .entrada-subtitulo {\n  color: #6b7682;\n  font-size: 14px;\n  margin: -8px 0 18px;\n  max-width: 760px;\n}\n\n.similarity-search-page .entrada-sin-documento {\n  color: #6b7682;\n  font-size: 13px;\n  margin: 10px 2px 0;\n}\n\n.similarity-search-page .entrada-sin-documento button {\n  border: none;\n  background: none;\n  padding: 0;\n  color: #2c6ca8;\n  font-family: inherit;\n  font-size: 13px;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.similarity-search-page .entrada-sin-documento button:hover { color: #1b4b76; }\n\n/* LAKPED-16.1 — la entrada de documentos copia los valores del prototipo de Paula.\n   Acotado a .entrada-documentos: las demás cuentas siguen viendo la pantalla de siempre. */\n.entrada-documentos h1 { font-size: 26px; font-weight: 600; margin: 0 0 4px; }\n.entrada-documentos .entrada-subtitulo { font-size: 14px; color: #666; margin: 0 0 20px; max-width: 760px; }\n\n.entrada-documentos .search-container {\n  border: 1px solid #e3e3e3;\n  border-radius: 10px;\n  box-shadow: none;\n  padding: 18px 20px;\n}\n\n.entrada-documentos .upload-section h3 { font-size: 15px; margin: 0 0 12px; }\n.entrada-documentos .file-upload { padding: 0; border: none; }\n\n.entrada-documentos .zona-arrastre {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 44px 24px;\n  border: 2px dashed #d5d5d5;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n}\n\n.entrada-documentos .zona-arrastre:hover { border-color: #111; background: #fafafa; }\n\n.entrada-documentos .zona-arrastre svg {\n  width: 30px;\n  height: 30px;\n  fill: none;\n  stroke: #111;\n  stroke-width: 1.6;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.entrada-documentos .zona-arrastre strong { font-size: 17px; color: #1b1b1b; }\n.entrada-documentos .zona-arrastre span { font-size: 13px; color: #777; }\n\n.entrada-documentos .entrada-sin-documento { font-size: 12.5px; color: #777; margin: 12px 2px 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
